import { PermissionValue } from '@schibsted-nmp/advertising-shared';

function getConsentAsync(): Promise<PermissionValue> {
  return new Promise((resolve) => {
    window?._tcf_?.isConsentedToAll((consentValue) => {
      resolve(consentValue ? '1' : '0');
    });
  });
}

function getConsentSync(): boolean | null {
  return window?._tcf_?.getConsentedToAllSync();
}

export function getConsentOrSubscribe(): Promise<PermissionValue> {
  return new Promise((resolve) => {
    const consentValueSync = getConsentSync();
    const consentNotSetYet = consentValueSync === null;

    if (consentNotSetYet) {
      let cancelled = false;

      const timer = setTimeout(() => {
        cancelled = true;
        resolve('0');
      }, 2000);

      (async () => {
        const permissionValue = await getConsentAsync();
        if (!cancelled) {
          clearTimeout(timer);
          resolve(permissionValue);
        }
      })();
    } else {
      resolve(consentValueSync ? '1' : '0');
    }
  });
}
